import { LegacyCard, Layout, Page } from '@shopify/polaris';

const ViewReports = () => {
  return <>
    <Page title="Informes" divider>
      <Layout>
        <Layout.Section>
          <LegacyCard>
            <LegacyCard.Section title="Informes">
              <p>Informes</p>
            </LegacyCard.Section>
          </LegacyCard>
        </Layout.Section>
      </Layout>
    </Page>
  </>;
};

export default ViewReports;
